import { STATUS_OPTIONS } from '@/constants';

export const PROSPECT_TEMPLATE_TYPE_LABELS: Record<string, string> = {
    QuoteIntake: 'Full Automation',
    IntakeOnly: 'Intake Only',
};

export function getTemplateTypeLabel(templateType?: string | null): string {
    if (!templateType) return '';
    return PROSPECT_TEMPLATE_TYPE_LABELS[templateType] ?? templateType;
}

export function getProspectStatusMeta(status?: string | null) {
    if (!status) return undefined;
    return STATUS_OPTIONS.find((st) => st.name === status);
}
